// extracted by mini-css-extract-plugin
export default {"anchor":"cookieBannerPanelLink_anchor"};